<template>
    <div id="index">
        <!-- 头部 -->
        <div class="head">
            <!-- <div class="headLeft" v-if="!logins" @click="popLogins">
                <img src="../assets/images/img_24.png" alt="">
                <span>未登录</span>
            </div> -->
            <div class="headLeft" @click="inPersonal">
                <img :src="userInfo.avatar?userInfo.avatar:require('../assets/images/photo.png')" alt="">
                <span>{{userInfo.name?userInfo.name:'钱大师'}}</span>
            </div>
            <img src="../assets/images/img_25.png" alt="" id="icons">
            <div class="headRight" @click="inIncomeDetails">
                收入明细>
            </div>
        </div>
        <!-- 余额、收益 -->
        <div class="profit">
            <div class="leftBalance">
                <div class="balanceT">
                    <div>我的余额</div>
                    <div class="inCashOut" @click="inCashOut">去提现 </div>
                </div>
                <div class="balanceB">
                    {{userInfo.balance}}
                </div>
            </div>
            <div class="rightProfit">
                <div class="profitText">
                    <span>今日收益</span>
                    <span>{{userInfo.today_income}}</span>
                </div>
                <div class="profitText">
                    <span>累计收益</span>
                    <span>{{userInfo.total_balance}}</span>
                </div>
            </div>
        </div>
        <!-- 公告 -->
        <div class="notice" v-show="noticeShow">
            <div class="noticeBox">
                <div class="noticeL">
                    <img src="../assets/images/img_26.png" alt="" id="noticeIcon">
                    <div class="noticeTips">
                        <!-- <span id="scrollNotice" :style="{transform: `translate(${trans}px)`}">公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告公告</span> -->
                        <span id="scrollNotice" :style="{transform: `translate(${trans}px)`}">{{notice.announcements}}</span>
                    </div>
                </div>
                <!-- <img src="../assets/images/img_27.png" alt="" id="noticeClose" @click="closeNotice"> -->
            </div>
        </div>

        <!-- 任务面板 -->
        <div class="taskPanel">
            <div class="one">
                <div class="one_1" @click="inFastTasks"><img src="../assets/images/img_42.png" alt=""></div>
                <div class="one_2" @click="inHighTask"><img src="../assets/images/img_32.png" alt=""></div>
            </div>
            <div class="two">
                <div class="two_1" @click="inApprentice"><img src="../assets/images/img_39.png" alt=""></div>
                <div class="twoRight">
                    <div class="two_2" @click="inCallbackTasks"><img src="../assets/images/yxrwb37.png" alt=""></div>
                    <div class="twoRight_b">
                        <div class="two_5" @click="inGameTask"><img src="../assets/images/img_35.png"></div>
                        <!-- <div v-if="isShowCommentTask == 1" class="two_3" @click="inGameTask"><img src="../assets/images/img_41.png" alt=""></div>
                        <div v-if="isShowCommentTask == 1" class="two_4" @click="inCommentTask"><img src="../assets/images/img_40.png" alt=""></div> -->
                    </div>
                </div>
            </div>
            <div class="three">
                <!-- <div v-if="isShowCommentTask == 0" class="three_1" @click="inXhyAdvert"><img src="../assets/images/img_34.png" alt=""></div> -->

                <div v-if="isShowCommentTask == 1" class="three_1" @click="inCommentTask"><img src="../assets/images/mds_screenshotask.png" alt=""></div>
                <!-- <div class="three_2" @click="inVipExclusive"><img src="../assets/images/img_33.png" alt=""> </div> -->
            </div>
        </div>

        <!-- 兑换视频会员 -->
        <!-- <div id="videoVip" @click="inExchangeVideoVip"><img src="../assets/images/img_63.png" alt=""></div> -->
        <div id="videoVip" @click='xuFei' v-if='isXuFei==1'
        ><img src="../assets/images/xufei.png" alt=""></div>

        <!-- <popupLogin @loginOrReg="loginOrReg" @sendCodes="sendCodes" :codes="codes" v-if="loginBoxs"></popupLogin> -->
        <!-- 21.4.28温馨提示弹窗 -->
         <pointPop></pointPop>
    </div>
</template>

<script>
    import common from '../assets/js/common.js';
    import {mapActions, mapState} from 'vuex'
      import { Dialog } from 'vant';
    // 引入 弹窗登录
    import popupLogin from '../components/PopupLogin.vue'
    // 馨提示弹窗 
    import pointPop from '../components/pointPop'

    import ajax from '../assets/js/ajax.js';

    export default {
        computed: {
            ...mapState(['userInfo','notice'])
        },
        components:{
            popupLogin,
            pointPop
        },
        data() {
            return {
                // logins:false, // 是否登录状态
                loginBoxs:false, // 是否弹窗
                // codes:'发送验证码',
                // flagCode:true,
                // systems:'',
                noticeShow:true,
                trans: 274,
                scrollTimer: null, // 公告滚动
                isShowCommentTask: 0, // 是否显示评论任务入口
                isXuFei:0 //续费 是否显示续费banner

            }
        },
        activated() {
            this.init();
            this.leftScroll();
        },
        deactivated() {
            clearInterval(this.scrollTimer);
        },
        mounted() {

        },
        methods: {
            ...mapActions(['changeUserA','changeNoticeA']),
            // 初始化 接口调用
            init:function(){
                this.$loading(true);
                let dataUser = {};
                //首页数据
                this.$http.GETS('Index/index',dataUser,(res)=>{
                    this.changeUserA(res.data.user)
                    this.changeNoticeA(res.data.system)
                    this.isShowCommentTask = res.data.is_show_comment;
                this.isXuFei = res.data.is_zao_wandu;
                    this.$loading(false);
                })
                // this.$http.GETS('Index/checkBounds')
            },
            // 进入 提现
            inCashOut(){
                // this.$router.push('/cashOut')
                // return
            this.$loading(true);
            let dataUser = {};
            this.$http.GETS('tuser_cash/validateTrueName',dataUser,(res)=>{
                this.$loading(false);
                if(res.flag === 'error'){
                   Dialog.alert({
                    title: '提示',
                    message: res.msg,
                    })
                return ;
                }
                switch (res.data) {
                    case 0:
                    //  this.$router.push('/authentication')   
                    this.$router.push('/mineInformation') 
                    break;
                    case 1:
                     this.$router.push('/mineInformation')    
                    break;
                    case 2:
                     this.$router.push('/mineInformation')    
                    break;
                    case 3:
                      this.$loading(true)
                      this.$http.GETS('tuser_cash/selectDqResult',{},(res)=>{
                          this.$loading(false);
                          if(res.data === '1') {
                              this.$router.push('/cashOut')
                          }else{
                              Dialog.alert({title: '提示',message:'签约中，请稍等'})
                          }
                      })
                      
                    break;
                    case 4:
                     this.$router.push('/cashOut')    
                    break;
                    default:
                        this.$toast('认证异常,请联系客服处理')
                }
            })
            },
            // 进入 个人中心
            inPersonal:function(){
                this.$router.push('/personal');
            },
            // 进入 收支明细
            inIncomeDetails:function(){
                this.$router.push('/incomeDetails');
            },
            // 进入 快速做任务
            inFastTasks:function(){
                this.$router.push('/fastTasks');
            },
            // 进入 高额任务
            inHighTask:function(){
                this.$router.push('/highTask');
            },
            // 进入 收徒页
            inApprentice:function(){
                this.$router.push('/apprentice');
            },
            // 进入 回调任务
            inCallbackTasks:function(){
                location.href = common.baseUrl + 'game_task/taskListTaojin';
                return false
            },
            // 进入 游戏任务
            inGameTask:function(){
                // this.$router.push('/gameTask');
                location.href = common.baseUrl + 'game_task/taskList';
            },
            // 进入 评论任务
            inCommentTask:function(){
                this.$router.push('/commentTask');
            },
            xuFei(){
                this.$http.GETS('/out_union/wanduClick', {}, (res) => {
                    if(res.code===2000){
                         window.location.href=res.data.jump_url;
                    }else{

                    }
                });
            },
            // 进入 小黑鱼广告
            inXhyAdvert:function(){
                // this.$router.push('/xhyAdvert');
                this.$http.GETS('/out_union/countXHYHYClick?type=hot', {}, (res) => {
                     window.location.href='https://p.blackfish.cn/p/yhy-paipai/01211058941200000';
                });
            },
            // 进入 会员专属福利
            inVipExclusive:function(){
                this.$router.push('/vipExclusive');
            },
            // 进入 兑换视频会员页
            inExchangeVideoVip:function(){
                this.$router.push('/exchangeVideoVip');
            },


            // 发送验证码
            // sendCodes:function(models){
            //     if(this.flagCode){
            //         let that = this
            //         let reg = /^1[3456789]\d{9}$/;
            //         if(!reg.test(models)){
            //             this.$toast('请输入正确的手机号码')
            //         }else{
            //             that.flagCode = false
            //             let nums = 60;
            //             let timer=setInterval(function(){
            //                 if(nums <= 0){
            //                     clearInterval(timer)
            //                     that.codes = '重发验证码'
            //                     that.flagCode = true
            //                 } else {
            //                     nums--
            //                     that.codes = nums+'s'
            //                 }
            //             },1000)
            //         }
            //     }
            // },
            // 弹窗点击登录
            // loginOrReg:function(models){
            //     let reg = /^1[3456789]\d{9}$/;
            //     if(!reg.test(models.phoneNum)){
            //         this.$toast('请输入正确的手机号码')
            //     }else{
            //         if(!models.captchas){
            //             this.$toast('请输入验证码')
            //         }else{
            //             this.logins = true;
            //             this.loginBoxs = false;
            //             this.$toast('登录成功')
            //         }
            //     }
            // },
            // 未登录 弹窗登录
            // popLogins:function(){
            //     this.loginBoxs = true;
            // },

            // 关闭公告
            // closeNotice:function(){
            //     this.noticeShow = false;
            // },

            // 横向滚动公告
            leftScroll(){
                let that = this;
                let scrollNotice = document.querySelector('#scrollNotice');
                // console.log();
                this.scrollTimer = setInterval(function(){
                    if(that.trans <= -scrollNotice.offsetWidth){
                        that.trans = 274
                    } else {
                        that.trans --;
                    }
                },40)
            },
        },
        beforeRouteEnter(to, from, next) {
            if(from.name=='cashOut' || from.name=='cashOutSuccess' || from.name=='exchangeVideoVip'){
                to.meta.keepAlive = false;
            } else {
                to.meta.keepAlive = true;
            }
            next();
        },
        beforeRouteLeave (to, from, next) {
            if(to.name=='callbackTask'||to.name=='/callbackTask'){
                location.href = common.baseUrl + 'game_task/taskListTaojin';
            }else{
                 next()
            }
        }
    }
</script>

<style lang="less" scoped>
    #index{
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        overflow: scroll;
        // 头部
        .head{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .headLeft{
                margin-left: 15px;
                display: flex;
                align-items: center;
                img{
                    width: 29px;
                    height: 29px;
                    border-radius: 50%;
                }
                span{
                    margin-left: 8px;
                    color: #FFFFFF;
                    font-size: 13px;
                }
            }
            #icons{
                width: 60px;
                height: 19px;
            }
            .headRight{
                margin-right: 15px;
                font-size: 13px;
                color: #FFFFFF;
            }
        }
        // 余额、收益
        .profit{
            height: 75px;
            padding: 15px 20px;
            color: rgba(0, 0, 0, .6);
            font-size: 13px;
            display: flex;
            box-shadow: 0 5px 5px rgba(229,229,229,.5);
            .leftBalance{
                padding-right: 10px;
                border-right: 1px solid rgba(229, 229, 229, .5);
                .balanceT{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .inCashOut{
                        width: 52px;
                        height: 22px;
                        border: 1px solid #979797;
                        border-radius: 12px;
                        font-size: 12px;
                        margin-left: 21px;
                        transform: scale(0.8);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .balanceB{
                    font-size: 40px;
                    color: #EB3C45;
                    font-weight: bold;
                    line-height: 40px;
                    margin-top: 9px;
                    font-family: "Qds";
                }
            }
            .rightProfit{
                margin-left: 30px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                .profitText{
                    display: flex;
                    span{
                        &:last-of-type{
                            color: #151515;
                            font-size: 20px;
                            font-weight: bold;
                            padding-left: 15px;
                            font-family: "Qds";
                            line-height: 20px;
                        }
                    }
                }
            }
        }
        // 公告
        .notice{
            padding: 15px 15px 0;
            .noticeBox{
                border: 1px solid rgba(229, 229, 229, .5);
                border-radius: 5px;
                padding: 6px;
                height: 23px;
                box-shadow: 0px 5px 10px rgba(0, 0, 0, .05);
                display: flex;
                align-items: center;
                justify-content: space-between;
                .noticeL{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    #noticeIcon{
                        width: 49px;
                        height: 23px;
                        margin-right: 6px;
                    }
                    .noticeTips{
                        width: 261px;
                        color: #151515;
                        font-size: 13px;
                        padding-right: 15px;
                        overflow: hidden;
                        #scrollNotice{
                            display: inline-block;
                            white-space: nowrap;
                        }
                    }
                }
                #noticeClose{
                    width: 9px;
                    height: 9px;
                    padding: 2px;
                    margin-right: 6px;
                }
            }
        }
        // 任务面板
        .taskPanel{
            margin: 0 17px;
            padding: 15px 0 0;
            .one{
                .one_1{
                    width: 219px;
                    height: 100px;
                    box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                    display: inline-block;
                }
                .one_2{
                    width: 115px;
                    height: 100px;
                    margin-left: 7px;
                    box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                    display: inline-block;
                }
            }
            .two{
                display: flex;
                margin: 10px 0;
                .two_1{
                    width: 148px;
                    height: 151px;
                    box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                    display: inline-block;
                }
                .twoRight{
                    margin-left: 7px;
                    .two_2{
                        width: 186px;
                        height: 68px;
                        box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                        display: inline-block;
                    }
                    .twoRight_b{
                        margin-top: 12px;
                        .two_3{
                            width: 90px;
                            height: 68px;
                            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                            display: inline-block;
                        }
                        .two_4{
                            margin-left: 7px;
                            width: 89px;
                            height: 68px;
                            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                            display: inline-block;
                        }
                        .two_5 {
                            width: 186px;
                        }
                    }
                }
            }
            .three{
                .three_1{
                    width: 167px;
                    height: 47px;
                    box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                    display: inline-block;
                }
                .three_2{
                    margin-left: 7px;
                    width: 167px;
                    height: 47px;
                    box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                    display: inline-block;
                }
            }
            img{
                width: 100%;
                height: 100%;
                pointer-events:none;
            }
        }
        // 兑换视频会员
        #videoVip{
            width: 341px;
            height: 68px;
            padding: 15px 17px;
            img{
                width: 100%;
                height: 100%;
                pointer-events:none;
            }
        }
    }
</style>